import { BigButton } from "components/atoms/buttons/ButtonStyled";
import { UnderlineText } from "components/atoms/text/Text";
import styled, { css } from "styled-components";
import { COLORS, LEVELS, switchStatusColor } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem, getSummaryCardStyle } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { SUBSCRIPTION_STATUS } from "api/interfaces/subscription.interface";
import { InnerPaddingWrapper } from "components/atoms/inner/InnerContainer";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";

export const SubscriptionTableWrapper = styled.div<{ $pathname: string }>`
  width: 100%;
`;

export const Row = styled.div<{ status?: boolean }>`
  ${FLEX.FlexStartCenter};
  gap: 8px;
  cursor: pointer;

  ${({ status }) =>
    status &&
    css`
      color: ${COLORS.SELECTED};
    `}

  img {
    width: 18px;
  }
`;

export const CommonWrapper = styled.div`
  width: 100%;
`;

export const Title = styled.div`
  ${FLEX.FlexBetweenCenter};
  padding-bottom: 12px;

  .essential {
    color: ${COLORS.RED};
    font-size: ${calcRem(14)};
    font-weight: 500;
  }
`;

export const RecorderRow = styled.div<{ status?: boolean }>`
  color: ${({ theme, status }) =>
    !status ? COLORS.LIGHTGRAY : theme.COLORS.WHITE};
  ${FLEX.FlexStartCenter};
  gap: 4px;

  .bubble-container {
    position: relative;
    ${FLEX.FlexCenterCenter};
    color: ${({ theme, status }) =>
      !status ? COLORS.LIGHTGRAY : theme.COLORS.WHITE};
  }
`;

export const SubscriptionOrgStyled = {
  SuspendOpenButton: styled.button`
    border: 1px solid #cacaca;
    color: ${COLORS.BLACK};
    font-size: ${calcRem(14)};
    border-radius: 2px;
    padding: 7px 15px;
    ${FLEX.FlexBetweenCenter};
    background-color: ${COLORS.WHITE};
    gap: 4px;
    text-transform: capitalize;
    &:disabled {
      background-color: ${({ theme }) => theme.COLORS.DISABLED};
      border-color: ${({ theme }) => theme.COLORS.DISABLED_BORDER};
      color: ${({ theme }) => theme.COLORS.DISABLED_BORDER};
      cursor: not-allowed;
    }
  `,
  SuspendBox: styled.div`
    .select-container > div {
      height: 30px;
      min-height: 30px;
      min-width: 100px;
      ${mediaQuery.isMobile} {
        min-width: unset;
        width: 100%;
      }
    }
  `,
  SuspendButton: styled.button`
    width: 100%;
    height: 30px;
    padding: 5px 15px;
    font-size: ${calcRem(14)};
    background-color: ${COLORS.WHITE};
    color: ${COLORS.BLACK};
    text-align: left;
    text-transform: capitalize;
    &:hover {
      background-color: ${COLORS.BUTTONS2}40;
      color: ${COLORS.BLACK};
    }
    &.active {
      background-color: ${COLORS.BUTTONS2};
      color: ${COLORS.WHITE};
    }

    + button {
      border-top: 1px solid #cacaca;
    }
  `,
  RequestBox: styled(UnderlineText)`
    ${FLEX.FlexStartCenter};
    gap: 0;
    flex-wrap: wrap;
    white-space: normal;
    word-break: break-word;

    > svg {
      width: 14px;
      margin-right: 6px;
    }
  `,
  AutoEnrollCell: styled.div`
    ${FLEX.FlexStartCenter};
    gap: 6px;

    .with-toolTip {
      ${FLEX.FlexCenterCenter};
    }

    svg {
      flex-shrink: 0;
      color: ${({ theme }) =>
        theme.value === "light" ? theme.COLORS.BUTTONS1 : COLORS.BUTTONS2};
    }
  `,
  TaxExemptTooltip: styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;

    > div {
      ${FLEX.FlexBetweenCenter};
      gap: 12px;
      white-space: nowrap;
    }

    > div > span:first-child {
      color: ${COLORS.LIGHTGRAY};
    }
  `,
};

export const SubscriptionHistoryStyled = {
  OrgInfoWrapper: styled(InnerPaddingWrapper)`
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 10px;
    width: 100%;
  `,
  SummaryWrapper: styled(InnerPaddingWrapper)`
    width: 100%;
  `,
  Header: styled(InnerPaddingWrapper)<{ isCoTermOpen: boolean }>`
    ${FLEX.FlexBetweenCenter};
    margin-bottom: 10px;
    ${mediaQuery.isMobile} {
      position: relative;
      flex-direction: column;
      width: 100%;
      align-items: flex-start;
      gap: 10px;
      > div {
        width: 100%;
      }
      ${({ isCoTermOpen }) =>
        isCoTermOpen &&
        css`
          margin-bottom: 0;
        `}
    }
  `,
  TopButtonWrapper: styled.div<{ isCoTermOpen: boolean }>`
    ${FLEX.FlexEndCenter};
    gap: 10px;

    /* button {
      background-color: ${COLORS.BUTTONS1};
      color: ${COLORS.WHITE} !important;
    } */
    ${mediaQuery.isMobile} {
      position: absolute;
      right: 0;
      bottom: 100%;
      margin-bottom: 10px;
      padding: 0 10px;
      .request-button {
        width: auto;
        padding: 8px 10px;
      }
      .info-button {
        width: auto;
        color: ${({ theme }) => theme.COLORS.WHITE};
        height: 30px;
        ${({ isCoTermOpen }) =>
          isCoTermOpen &&
          css`
            margin-right: 10px;
          `}
      }
    }
  `,
  Inner: styled.div`
    width: 100%;
    position: relative;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 30px;
    .table-wrapper {
      flex: none;
    }
    .ant-table-wrapper {
      height: auto;
    }
    .ant-table-content {
      min-height: 0;
      height: auto;
    }
    > ul {
      margin-bottom: -10px;
    }
  `,
  SubscriptionTypeInner: styled.div`
    overflow: hidden;
    width: 100%;
    .ant-table-content {
      min-height: 0 !important;
      overflow: visible;
    }
    ${mediaQuery.isMobile} {
      overflow: visible;
      .ant-table-content {
        overflow: hidden;
      }
    }
  `,

  EuSubscriptionWrapper: styled.div<{ $level: LEVEL_TYPE }>`
    width: 100%;
    ${FLEX.FlexBetweenStart};

    @media (max-width: 1399px) {
      flex-direction: column;
    }
    ${({ $level }) =>
      $level === LEVEL_TYPE.EU &&
      css`
        ${mediaQuery.isTablet} {
          padding-right: 20px;
        }
        ${mediaQuery.isMobile} {
          padding-right: 0;
        }
      `}
    ${mediaQuery.isMobile} {
      gap: 0;
    }
  `,
  TableWrapper: styled.div`
    width: 100%;
    flex: 4;
    .table-template > .subheader {
      padding-top: 0;
    }
    .right-aside {
      flex: auto;
    }
    .routes-mark-wrapper {
      display: none;
    }
    .header-container {
      padding-top: 0;
      position: relative;
      > div:first-child {
        flex: auto;
      }
      ${mediaQuery.isTablet} {
        flex-direction: row;
      }
      ${mediaQuery.isMobile} {
        flex-direction: column;
      }
    }
  `,

  CoTermToggle: styled.button`
    position: absolute;
    right: 0;
    top: 107px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background: ${({ theme }) => theme.COLORS.BUTTONS3};
    color: ${COLORS.WHITE};
    backdrop-filter: blur(6px);
    cursor: pointer;
    user-select: none;
    writing-mode: vertical-rl; /* 세로쓰기 */
    text-orientation: mixed; /* 글자가 90도 회전하지 않고 정상적으로 세로 표시 */
    ${mediaQuery.isTablet} {
      top: 98px;
    }
    ${mediaQuery.isMobile} {
      top: 85px;
      right: 180px;
      background: transparent;
      color: ${({ theme }) => theme.COLORS.WHITE};
      backdrop-filter: none;
      writing-mode: horizontal-tb;
      svg {
        vertical-align: middle;
        margin-top: -2px;
      }
      .icon {
        display: none;
      }
    }
  `,

  CoTermAside: styled.div`
    max-width: 20%;
    min-width: 300px;
    margin-left: 20px;

    @media (max-width: 1399px) {
      max-width: 100%;
      min-width: 100%;
      margin-left: 0;
    }
    .co-term-drawer {
      will-change: transform;
    }
  `,
};

export const SubscriptionCoTermStyled = {
  TermWrapper: styled.ul`
    flex: 1 1 0;
    min-width: 300px;
    background-color: ${({ theme }) => theme.COLORS.FILTERITEM};
    padding: 0 20px;
    border-radius: 4px;

    a {
      text-decoration: underline;
      color: ${({ theme }) => theme.COLORS.SELECTED};
    }
    ${mediaQuery.isMobile} {
      min-width: 0;
      margin-top: -20px;
    }
  `,
  TermItem: styled.li`
    width: 100%;
    &:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
    }

    .title {
      width: 100%;
      ${FLEX.FlexBetweenCenter};
      gap: 20px;
      padding: 16px 0;
      cursor: pointer;
      color: ${({ theme }) => theme.COLORS.WHITE};

      h2 {
        font-size: ${calcRem(20)};
        font-weight: 500;
      }
      .icon {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        ${FLEX.FlexEndCenter}
      }
    }

    .content {
      padding: 10px 0;
      color: ${({ theme }) => theme.COLORS.TEXT};
      font-size: ${calcRem(15)};
      line-height: ${calcRem(20)};
      border-top: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
    }
  `,
};

export const SubscriptionKeyListStyled = {
  Container: styled.div`
    width: 100%;
  `,
  CpWrapper: styled.div`
    ${FLEX.FlexStartStart};
    gap: 4px;
    > div {
      flex: 1;
    }
    .account-id-label + span {
      line-clamp: 1;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      white-space: normal;
    }
    .sort-icon {
      display: inline-flex;
      gap: 0.1em;
      flex-direction: column;
      vertical-align: middle;
      margin: -3px 0 0 4px;
      &:before,
      &:after {
        content: "";
        width: 0;
        height: 0;
        border: solid transparent;
        border-width: 0.325em 0.325em;
        transform: scaleY(1.01);
      }
      &:before {
        border-bottom-color: ${({ theme }) => theme.COLORS.WHITE};
      }
      &:after {
        border-top-color: ${({ theme }) => theme.COLORS.WHITE};
      }
      &.asc:before {
        border-bottom-color: ${({ theme }) => theme.COLORS.SELECTED};
      }
      &.desc:after {
        border-top-color: ${({ theme }) => theme.COLORS.SELECTED};
      }
    }
    @media (max-width: 1399px) {
      .SubCP {
        display: none;
      }
    }
  `,
  SearchWrapper: styled.div`
    width: 100%;
    ${FLEX.FlexEndCenter};
    margin-bottom: 16px;

    > div {
      gap: 10px;
      max-width: 400px;
      ${FLEX.FlexEndCenter};
      ${mediaQuery.isMobile} {
        max-width: 100%;
        width: 100%;
        button {
          flex: none;
          width: auto;
        }
      }
    }
  `,

  ReplaceButton: styled.button`
    background-color: ${({ theme }) => theme.COLORS.BUTTONS2};
    border-radius: 2px;
    color: ${COLORS.WHITE};
    padding: 4px;
    ${FLEX.FlexCenterCenter};
  `,
  CalendarButton: styled.div`
    cursor: pointer;
  `,
  SubscriptionKeyListWrapper: styled.div`
    height: 100%;

    .header-container {
      @media (max-width: 1399px) {
        padding-top: 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
      ${mediaQuery.isMobile} {
        padding-top: 0;
      }
    }
    .right-aside {
      position: relative;
      z-index: 2;
      @media (max-width: 1399px) {
        width: 100%;
      }
      ${mediaQuery.isMobile} {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        > div {
          width: 100%;
        }
      }
    }
    .duration-column {
      .duration-label {
        display: inline-block;
      }
      .duration-days {
        display: inline-block;
      }
    }
  `,
  CalendarWrapper: styled.div`
    width: 245px;
    position: relative;
    > label {
      color: ${({ theme }) => theme.COLORS.TEXT};
      font-size: ${calcRem(14)};
      margin-bottom: 4px;
      position: absolute;
      left: 0;
      bottom: 100%;
    }
    @media (max-width: 1399px) {
      + div {
        max-width: none;
        flex: 1;
      }
    }
  `,
  DateFilterGroup: styled.div`
    ${FLEX.FlexStartCenter};
    gap: 8px;
    @media (max-width: 1399px) {
      width: 100%;
    }
    ${mediaQuery.isMobile} {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      > div {
        width: 100%;
      }
    }
  `,
  DateTypeSelectWrapper: styled.div`
    width: 150px;
    flex: none;
  `,
  ExpireDateBox: styled.span<{
    status: SUBSCRIPTION_STATUS | string;
  }>`
    color: ${({ status, theme }) =>
      switchStatusColor(
        status === SUBSCRIPTION_STATUS.ACTIVATED ? "default" : status,
        theme.value
      )};

    ${({ status, theme }) =>
      status === SUBSCRIPTION_STATUS.EXPIRED_END &&
      css`
        font-weight: 500;
      `}
    ${FLEX.FlexStartCenter};
    gap: 4px;
    .with-toolTip {
      ${FLEX.FlexStartCenter}
    }
  `,
  ButtonWrapper: styled.div`
    ${FLEX.FlexStartCenter};
    gap: 8px;
  `,
};

export const RegisterKeyModalStyled = {
  Title: styled.div`
    padding: 30px 0 10px;
    font-size: ${calcRem(18)};
    ${FLEX.FlexCenterCenter};
    gap: 6px;
    flex-direction: column;
    color: ${({ theme }) => theme.COLORS.WHITE};

    .subtitle {
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS.COMPANY};
    }
  `,
  Inner: styled.div`
    width: 100%;
    padding: 20px 0;
    flex: 1;
    ${FLEX.FlexStartStart};
    gap: 10px;
    flex-direction: column;

    .input-inner {
      width: 100%;
      flex: 1;
      max-height: 350px;
      overflow-y: auto;
      ${FLEX.FlexStartStart};
      gap: 10px;
      flex-direction: column;
    }
  `,
  InputWrapper: styled.div`
    width: 100%;
    position: relative;

    .delete-button {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translate(0, -50%);
      color: ${COLORS.COMPANY};
    }
  `,
  AddButtonWrapper: styled.div`
    width: 100%;
    ${FLEX.FlexBetweenCenter}
  `,
  UploadButton: styled(BigButton)`
    > input {
      display: none;
    }
  `,
};

export const SubscriptionCommonWrapper = styled.div`
  width: 100%;

  .info {
    margin-top: 30px;

    .common-modal-input {
      gap: 20px !important;
    }
    .modal-input-label-title {
      font-weight: normal;
      font-size: ${calcRem(18)};
    }

    .value {
      font-size: ${calcRem(32)};
      font-weight: 500;
    }
  }
`;

export const InfoBoxStyled = {
  Box: styled.div`
    background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
    border-radius: 6px;
    padding: 20px;
    padding-top: 10px;

    .title {
      font-weight: 500;
      padding-bottom: 10px;
      ${FLEX.FlexStartCenter};
      column-gap: 10px;
      row-gap: 3px;
      flex-wrap: wrap;
      font-size: ${calcRem(16)};
    }

    .info-title {
      border-bottom: 1px solid ${COLORS.BORDER};
      ${FLEX.FlexBetweenCenter};
      flex-wrap: wrap;
      min-height: 34px;
    }

    .info-inner {
      ${FLEX.FlexStartStart};
      gap: 4px;
      flex-direction: column;
      padding: 10px 0;

      .content-box {
        width: 100%;
        ${FLEX.FlexBetweenEnd};

        > ul {
          flex: 2;
          ${FLEX.FlexStartStart};
          flex-direction: column;
          gap: 6px;
        }
      }
    }
  `,
};

export const PlanModal = {
  Title: styled.div`
    ${FLEX.FlexStartCenter};
    flex-direction: column;
    gap: 6px;
    .account-name-label {
      font-weight: 500;
      line-height: 1.25;
      color: ${({ theme }) => theme.COLORS?.WHITE};
    }
    h3,
    p {
      font-size: ${calcRem(13)};
      color: ${({ theme }) => theme.COLORS?.WHITE}80;
    }
    p {
      padding-top: 10px;
      width: 100%;
      line-height: 1.25;
    }
    h3 {
      font-size: ${calcRem(13)};
      color: ${({ theme }) => theme.COLORS.WHITE}80;
    }
    .account-info-label {
      flex-direction: column;
      align-items: center;
      color: ${({ theme }) => theme.COLORS.WHITE};
      row-gap: 6px;
      font-size: ${calcRem(16)};
      .account-id-label + span {
        font-weight: 500;
      }
    }
  `,
  Wrapper: styled.div`
    ${FLEX.FlexCenterCenter};
    flex-direction: column;
    gap: 20px;
    margin: -20px 0;
    max-width: 400px;
    > p {
      width: 100%;
      color: ${({ theme }) => theme.COLORS?.WHITE}80;
    }
    p {
      width: 100%;
      color: ${({ theme }) => theme.COLORS.WHITE}80;
      font-size: ${calcRem(14)};
      text-align: center;
      line-height: 1.25;
      + p {
        color: ${({ theme }) => theme.COLORS.WHITE};
        font-weight: 500;
        font-size: ${calcRem(16)};
      }
    }
  `,
  InfoWrapper: styled.div`
    ${FLEX.FlexStartStart};
    gap: 10px;
    flex-direction: column;
    width: 100%;
    padding-top: 10px;
    background-color: ${({ theme }) => theme.COLORS.SELECTED}10;
    border: 1px solid ${({ theme }) => theme.COLORS.SELECTED}70;
    color: ${({ theme }) => theme.COLORS.WHITE};
    border-radius: 5px;
    padding: 20px;
  `,
  InfoItem: styled.div`
    width: 100%;
    ${FLEX.FlexBetweenCenter};
    font-size: ${calcRem(14)};
    label {
      color: ${({ theme }) => theme.COLORS.WHITE}80;
    }
    b {
      font-weight: 500;
      font-size: ${calcRem(16)};
      &.channel-usage,
      &.storage-usage {
        color: ${({ theme }) => theme.COLORS.SELECTED};
      }
      &.storage-used span {
        font-weight: 400;
      }
    }
  `,
  StorageWrapper: styled.div`
    ${FLEX.FlexStartStart};
    gap: 10px;
    flex-direction: column;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.COLORS.SELECTED}70;
    border-radius: 5px;
    padding: 0 20px 10px;
  `,
  StorageUpdate: styled.div`
    width: 100%;
    max-width: 400px;
    p {
      text-align: left;
      font-weight: 400;
    }
    .remaining-card {
      min-height: 0;
      margin-bottom: 10px;
    }
  `,
  StorageUsage: styled.div`
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 4px;
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-weight: 500;
    font-size: ${calcRem(20)};
    background-color: ${({ theme }) => theme.COLORS.SELECTED}10;
    margin: 0 -20px;
    width: calc(100% + 40px);
    border-bottom: 1px dashed ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
    padding: 20px;
    .storage-usage-add {
      color: ${({ theme }) => theme.COLORS.SELECTED};
      font-weight: 500;
    }
    label {
      font-size: ${calcRem(16)};
      padding-bottom: 4px;
    }
    span {
      font-weight: 400;
    }
    b.storage-usage {
      ${FLEX.FlexBetweenCenter};
      width: 100%;
      padding-top: 4px;

      .storage-usage-section {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      .storage-usage-total {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-end;
      }
      .storage-usage-subtitle {
        font-size: ${calcRem(14)};
        font-weight: 400;
        color: ${({ theme }) => theme.COLORS.WHITE}80;
      }
    }
  `,
  StorageUpdateTitle: styled.p`
    ${FLEX.FlexStartStart};
    gap: 10px;
    flex-direction: column;
    padding-top: 10px;
    font-weight: 500;
    label {
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS.WHITE};
    }
    b {
      color: ${({ theme }) => theme.COLORS.SELECTED};
      font-size: ${calcRem(24)};
    }
  `,
};

export const UsagePlan = {
  OutletWrapper: styled.div<{ $level: LEVEL_TYPE }>`
    overflow: hidden;
    width: 100%;
    .header-container .title-left {
      flex: auto;
    }
    &._subscription_organization_history .header-container {
      ${mediaQuery.isTablet} {
        position: relative;
        .request-button {
          position: absolute;
          top: 0;
          right: 20px;
          width: auto;
        }
        .right-aside > div {
          max-width: 100%;
          width: 100%;
        }
      }
      ${mediaQuery.isMobile} {
        padding-top: 50px;
        .request-button {
          width: auto;
          right: 0;
          padding: 8px 10px;
        }
      }
      ${({ $level }) =>
        $level === LEVEL_TYPE.EU &&
        `
        ${mediaQuery.isTablet} {
          padding-right: 20px;
        }
        ${mediaQuery.isMobile} {
          padding-right: 0;
        }
      `}
    }
    &._subscription_keys_list {
      .header-container {
        @media (max-width: 1399px) {
          padding-top: 16px;
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
        }
        ${mediaQuery.isMobile} {
          padding-top: 0;
        }
      }
      .right-aside {
        position: relative;
        z-index: 2;
        @media (max-width: 1399px) {
          width: 100%;
        }
        ${mediaQuery.isMobile} {
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
          > div {
            width: 100%;
          }
        }
      }
      .duration-column {
        .duration-label {
          display: inline-block;
        }
        .duration-days {
          display: inline-block;
        }
      }
    }
  `,
  Wrapper: styled.div`
    padding-bottom: 60px;
    .title-left {
      flex: auto;
    }
  `,

  SummaryWrapper: styled(InnerPaddingWrapper)`
    ${FLEX.FlexCenterCenter};
    flex-direction: column;
    width: 100%;
    gap: 20px;
    .subheader {
      padding-top: 10px;
    }
    .title-left {
      flex: auto;
    }
  `,
  TopWrapper: styled.div`
    width: 100%;
    ${FLEX.FlexBetweenCenter};
    padding-top: 26px;
    gap: 10px;
    ${mediaQuery.isMobile} {
      flex-direction: row-reverse;
    }
  `,
  CardWrapper: styled.div<{ columns: number }>`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    ${mediaQuery.isDesktop} {
      grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
      gap: 20px;
    }
    ${({ columns }) =>
      columns > 4 &&
      css`
        @media (max-width: 1500px) {
          grid-template-columns: repeat(3, 1fr);
        }
      `}
    ${mediaQuery.isMobile} {
      grid-template-columns: repeat(1, 1fr);
    }
  `,
  Card: styled.div`
    ${FLEX.FlexStartCenter};
    padding: 20px;
    gap: 15px;
    color: ${({ theme }) => theme.COLORS.WHITE};
    min-height: 110px;
    ${({ theme }) => getSummaryCardStyle(theme)};

    ${mediaQuery.isDesktop} {
      width: 100%;
    }

    .with-toolTip {
      ${FLEX.FlexStartCenter};
      width: 100%;
      height: 100%;
      gap: 15px;
      cursor: help;
    }
  `,
  GraphWrapper: styled.div`
    width: 100%;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    ${({ theme }) => getSummaryCardStyle(theme)};
    padding: 20px;
    gap: 10px;
    color: ${({ theme }) => theme.COLORS.WHITE};

    &.storage-allocation-panel,
    &.storage-monthly-summary-panel {
      gap: 14px;
      padding: 24px;
    }

    &.storage-changes-panel {
      ${FLEX.FlexCenterCenter};
      min-height: 74px;
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS.WHITE}80;
    }

    .storage-panel-header {
      ${FLEX.FlexBetweenCenter};
      width: 100%;
      gap: 12px;
      flex-wrap: wrap;
    }

    .storage-panel-header .header-left {
      ${FLEX.FlexStartCenter};
      gap: 12px;
      min-width: 220px;
      flex: 1;
    }

    .storage-panel-header .header-icon {
      width: 44px;
      height: 44px;
      border-radius: 12px;
      ${FLEX.FlexCenterCenter};
      color: ${COLORS.BUTTONS2};
      flex: 0 0 auto;
    }

    .storage-panel-header .header-text {
      min-width: 0;
    }

    .storage-panel-header h3 {
      font-size: ${calcRem(18)};
      font-weight: 500;
      line-height: 1.2;
      margin: 0;
    }

    .storage-panel-header p {
      margin: 3px 0 0 0;
      font-size: ${calcRem(13)};
      color: ${({ theme }) => theme.COLORS.WHITE}80;
      line-height: 1.25;
    }

    .storage-panel-header .header-right-value {
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.WHITE};
      white-space: nowrap;
      text-align: right;
    }

    .storage-credit-usage {
      width: 100%;
    }

    .storage-credit-usage .credit-usage-title {
      font-size: ${calcRem(13.5)};
      color: ${({ theme }) => theme.COLORS.WHITE}80;
      margin-bottom: 8px;
    }

    .storage-credit-usage .credit-usage-bar {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr auto;
      align-items: center;
      gap: 14px;
    }

    .storage-credit-usage .credit-usage-track {
      position: relative;
      height: 16px;
      border-radius: 10px;
      overflow: hidden;
      background-color: ${({ theme }) => theme.COLORS.BACKGROUND}55;
      border: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
    }

    .storage-credit-usage .credit-usage-fill {
      height: 100%;
      width: 0%;
      background: linear-gradient(
        90deg,
        ${({ theme }) => theme.COLORS.GREEN},
        ${COLORS.BUTTONS2}
      );
      border-radius: 10px;
    }

    .storage-credit-usage .credit-usage-percent {
      font-size: ${calcRem(14)};
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.WHITE};
    }

    .storage-credit-usage .credit-usage-caption {
      font-size: ${calcRem(13)};
      color: ${({ theme }) => theme.COLORS.WHITE}80;
      white-space: nowrap;
      text-align: right;
    }

    .storage-allocation-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .storage-allocation-list .allocation-row {
      ${FLEX.FlexBetweenCenter};
      width: 100%;
      gap: 14px;
      padding: 12px 14px;
      border-radius: 8px;
      background-color: ${({ theme }) => theme.COLORS.BACKGROUND}30;
      border: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
    }

    .storage-allocation-list .allocation-left {
      ${FLEX.FlexStartStart};
      flex-direction: column;
      gap: 8px;
      min-width: 0;
      flex: 1;
    }

    .storage-allocation-list .allocation-org {
      font-size: ${calcRem(13.5)};
      line-height: 1.2;
      min-width: 0;
      ${FLEX.FlexStartCenter};
      gap: 8px;
    }

    .storage-allocation-list .allocation-since {
      font-size: ${calcRem(12.5)};
      color: ${({ theme }) => theme.COLORS.WHITE}70;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .storage-allocation-list .allocation-right {
      ${FLEX.FlexEndCenter};
      gap: 30px;
      flex: 0 0 auto;
    }

    .storage-allocation-list .allocation-metric {
      justify-self: end;
      text-align: right;
    }

    .storage-allocation-list .allocation-value {
      font-size: ${calcRem(13.5)};
      white-space: nowrap;
      text-align: right;
      line-height: 1.15;
    }

    .storage-allocation-list .allocation-sub {
      margin-top: 3px;
      color: ${({ theme }) => theme.COLORS.WHITE}60;
      font-size: ${calcRem(12.5)};
      white-space: nowrap;
    }

    .storage-allocation-list .allocation-action {
      background: transparent;
      border: 0;
      padding: 0;
      color: ${COLORS.BUTTONS2};
      font-size: ${calcRem(13)};
      font-weight: 500;
      cursor: pointer;
      white-space: nowrap;
      text-decoration: underline;
      text-underline-offset: 3px;
      opacity: 0.95;
      display: inline-flex;
      align-items: center;
    }

    .storage-allocation-list .allocation-action:hover {
      opacity: 1;
    }

    .storage-allocation-list .allocation-action-left {
      margin-top: 6px;
      align-self: flex-start;
    }

    .storage-empty-note {
      width: 100%;
      font-size: ${calcRem(13.5)};
      color: ${({ theme }) => theme.COLORS.WHITE}80;
      line-height: 1.35;
      padding: 10px 0 4px 0;
    }

    ${mediaQuery.isMobile} {
      .storage-credit-usage .credit-usage-bar {
        grid-template-columns: 1fr;
      }

      .storage-credit-usage .credit-usage-caption {
        justify-self: end;
      }

      .storage-allocation-list .allocation-row {
        align-items: flex-start;
      }

      .storage-allocation-list .allocation-right {
        align-items: flex-end;
      }

      .storage-allocation-list .allocation-metric {
        min-width: 0;
      }

      .storage-allocation-list .allocation-value {
        text-align: right;
      }
    }

    .monthly-summary-header h3 {
      font-size: ${calcRem(18)};
      font-weight: 500;
      margin: 0;
    }

    .monthly-summary-body {
      width: 100%;
      display: grid;
      gap: 10px;
      padding-top: 6px;
    }

    .monthly-summary-body .summary-row {
      ${FLEX.FlexBetweenCenter};
      width: 100%;
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS.WHITE};
    }

    .monthly-summary-body .summary-row > span {
      color: ${({ theme }) => theme.COLORS.WHITE}70;
      font-size: ${calcRem(13.5)};
    }

    .monthly-summary-body .summary-row > b {
      font-weight: 500;
      white-space: nowrap;
    }

    .monthly-summary-body .summary-divider {
      width: 100%;
      height: 1px;
      background-color: ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
      opacity: 0.6;
      margin: 4px 0;
    }
  `,
  GraphInnterWrapper: styled.div`
    ${FLEX.FlexStartStart};
    width: 100%;
    height: 200px;
  `,
  CardIcon: styled.div<{ $status?: string }>`
    svg {
      width: 25px;
      height: 25px;
    }
    color: ${({ $status, theme }) =>
      $status && $status !== SUBSCRIPTION_STATUS.ACTIVATED && $status !== "OK"
        ? switchStatusColor($status, theme.value)
        : theme.COLORS.WHITE};
    &.used-icon,
    &.storage-used-icon {
      color: ${COLORS.BUTTONS2};
    }
    &.estimateCost-icon,
    &.remaining-icon {
      color: ${({ theme }) => theme.COLORS.GREEN};
      svg {
        width: 30px;
        height: 30px;
      }
    }
    &.endUsers-icon {
      color: ${LEVELS.EU};
    }
    &.activeChannels-icon {
      color: ${COLORS.COMPANY};
    }
    &.activeStorage-icon {
      color: ${COLORS.BUTTONS2};
    }
    &.burnRate-icon {
      color: ${COLORS.BUTTONS1};
    }
    &.projection-icon {
      color: ${COLORS.RED};
    }
    &.danger {
      color: ${COLORS.VALIDATERED};
    }
    font-size: ${calcRem(28)};
  `,
  CardContent: styled.div`
    ${FLEX.FlexStartStart};
    gap: 4px;
    flex-direction: column;
    .title {
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS?.WHITE}80;
      svg {
        vertical-align: middle;
        margin: -3px 0 0 4px;
      }
    }
    .value {
      font-size: ${calcRem(24)};
      font-weight: 500;
      padding-top: 2px;

      &.danger {
        color: ${COLORS.VALIDATERED};
      }
    }
    .description {
      font-size: ${calcRem(13)};
      color: ${({ theme }) => theme.COLORS?.WHITE}80;
      line-height: 1.25;
      b {
        font-weight: 500;
      }
    }
    .breakdown-link {
      ${FLEX.FlexStartCenter};
      gap: 4px;
      margin-top: 2px;
      color: ${({ theme }) => theme.COLORS.BUTTONS2};
      font-size: ${calcRem(12.5)};
      font-weight: 500;
      cursor: pointer;

      svg {
        flex-shrink: 0;
      }

      :hover {
        text-decoration: underline;
      }
    }
  `,
  TooltipCard: styled.div`
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 6px;
    padding: 14px 16px;
    box-sizing: border-box;

    .tooltip-title {
      font-size: ${calcRem(13.5)};
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.WHITE};
    }

    .tooltip-desc {
      font-size: ${calcRem(12.5)};
      line-height: 1.5;
      color: ${({ theme }) => theme.COLORS.WHITE}80;
    }

    .tooltip-example {
      width: 100%;
      margin-top: 4px;
      padding-top: 8px;
      border-top: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
      font-size: ${calcRem(12.5)};
      line-height: 1.5;
      color: ${({ theme }) => theme.COLORS.WHITE};
    }
  `,
  GraphTitle: styled.div`
    ${FLEX.FlexStartCenter};
    gap: 10px;
    flex-wrap: wrap;
    width: 100%;
    h3 {
      font-size: ${calcRem(16)};
      color: ${({ theme }) => theme.COLORS.WHITE};
      font-weight: 500;
    }
    .tab {
      font-size: ${calcRem(13.5)};
      padding: 0 10px;
      height: 30px;
    }
    .select-container {
      width: auto;
      > div {
        height: 30px;
        min-height: 30px;
        max-height: 30px;
      }
    }
  `,
  GraphContent: styled.div`
    width: 100%;
    ${FLEX.FlexStartStretch};
    height: 200px;
    gap: 10px;
    position: relative;
    & svg {
      overflow: visible;
    }
  `,
  GraphPayDay: styled.div<{ $left: number }>`
    position: absolute;
    left: ${({ $left }) => $left}px;
    top: 0;
    height: 100%;
    transform: translateX(-50%);
    pointer-events: none;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: 10px;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 1px dashed ${({ theme }) => theme.COLORS.BORDER};
    }

    .payday-day {
      font-size: ${calcRem(12)};
      white-space: nowrap;
      padding: 3px 0 6px;
      color: ${({ theme }) => theme.COLORS.GREEN};
      font-weight: 500;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      label {
        position: absolute;
        bottom: 100%;
        left: 50%;
        background: ${COLORS.BLACK};
        color: ${COLORS.GREEN};
        border-radius: 4px;
        padding: 4px 8px;
        font-size: ${calcRem(13)};
        font-weight: 500;
        white-space: nowrap;
        z-index: 1;
        transform: translateX(-50%);
        margin-bottom: 10px;
        text-align: center;
        ${mediaQuery.isMobile} {
          white-space: normal;
        }
        &:before {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border: solid transparent;
          border-width: 4px;
          border-top-color: ${COLORS.BLACK};
        }
      }
    }
    .payday-date {
      font-size: ${calcRem(14)};
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      color: ${({ theme }) => theme.COLORS.WHITE};
      line-height: 1.5;
      font-weight: 500;
      white-space: nowrap;
    }
  `,
  GraphYAxis: styled.div`
    ${FLEX.FlexBetweenStart};
    flex-direction: column;
    gap: 4px;
    font-size: ${calcRem(12)};
    color: ${({ theme }) => theme.COLORS?.WHITE}80;
    height: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    span {
      display: inline-block;
      transform: translateY(-50%);
    }
  `,
  GraphInner: styled.div`
    flex: 1;
    min-width: 0;
  `,
  SummaryTypeWrapper: styled.div`
    ${FLEX.FlexBetweenCenter};
    flex-direction: row-reverse;
    width: 100%;
    gap: 10px;
  `,
  ManagePlanButtonWrapper: styled.div`
    width: 100%;
    position: relative;
  `,
  ManagePlanButtonList: styled.div`
    ${FLEX.FlexStartCenter};
    flex-direction: column;
    position: absolute;
    background: ${COLORS.WHITE};
    border-radius: 6px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    top: 100%;
    right: 0;
    margin-top: 10px;
    button {
      width: 100%;
      padding: 12px 15px;
      ${FLEX.FlexStartCenter};
      gap: 10px;
      text-align: left;
      color: ${COLORS.BLACK};
      font-size: ${calcRem(14)};
      &:hover {
        background: ${COLORS.BUTTONS2}10;
      }
      + button {
        border-top: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
      }
    }
  `,
};

export const SuspendWrapper = styled.div`
  width: 200px;

  .suspend-button {
    max-width: 120px;
  }
`;
